<template>
    <div class="fundo-dados">

        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard"
                        :isFinalizado="ocorrencia.flFinalizado" />

        <div class="d-flex" v-if="ocorrencia.idInstituicao > 0">
            <div class="flex-grow-1 ms-2 ">
                <InputSearch v-model="filtro_text" placeholder="Pesquisar por Nome, E-mail, Departamento ou Função..." @updateSearch="reloadGrid" @keypress.enter="reloadGrid" />
            </div>
            <div class="ms-2">
                <button type="button" class="btn btn-new-crud" v-on:click="newContatoCrud">
                    <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar novo contato</span>
                </button>
            </div>
        </div>


        <div class="row box-ticket data-dados mt-3" style="        margin-top: -15px;" v-if="ocorrencia.idInstituicao > 0">

            <!-- TODOS CONTATOS -->
            <div class="col table-dados" style="        padding-left: 10px;" v-if="idModulo != 0 && idInstituicao != 0">
                <DataTable :url_ajax="getUrlTodosContatos()"
                           :customHeightPaginate="lowHeightPage" :customHeight="lowHeightNoPage"
                           :ajax_set_result="setHistorico" @grid_refreshed="gridRefreshed" :refresh="refresh_grid"
                           :filtros="filtro" method="GET" :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="false"
                           :headers="headersTodosContatos" :pBtnsSlot="true" :is_NotLoading="NotLoading" :is_modal="true"
                           sizeWidBooton="width:102%;" :request_api="'comercial'">
                    <template v-slot:BtnSlot="item">
                        <div class="campo">
                            <div class="d-flex mb-1">
                                <div class="col-6" v-on:click="historicoPessoa(item.row.idPessoa)">
                                    <h3 class="mb-0">Nome</h3>
                                    <span class="data text-break" style="        text-align: left;">{{ item.row.nmPessoa }}</span>
                                </div>
                                <div class="col-3">
                                    <h3 class="mb-0">Departamento</h3>
                                    <span class="data ">{{ item.row.nmDepartamento }}</span>
                                </div>
                                <div class="col-3">
                                    <button class="btn-grid-excluir-lista btn-arrow" @click="favoritar(item.row.idPessoa)">
                                        <i class="fas fa-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="col">
                                    <h3 class="mb-0">E-Mail</h3>
                                    <span class="data">{{ item.row.dsEmail }}</span>
                                </div>
                                <div class="col-3">
                                    <div class="row" v-if="item.row.flCelularValido && conta_whats_ativa">
                                        <div class="col-12">
                                            <button class="btn-grid-editar-lista btn-grid btn-whats" @click="OpenModalConfirmacaoIniciar(item.row.idPessoa)">
                                                <i class="fab fa-whatsapp"></i><span class="btn-span-text">Whats</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid btn-editar"
                                                    @click="editContatoCrud(item.row.idPessoa)">
                                                <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid"
                                                    @click="ligar(item.row.idPessoa)">
                                                <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-12">
                                            <button type="button" class="btn-grid-editar-lista btn-grid btn-editar"
                                                    @click="editContatoCrud(item.row.idPessoa)">
                                                <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid"
                                                    @click="ligar(item.row.idPessoa)">
                                                <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </DataTable>
            </div>

            <!-- PRIORITARIOS -->
            <div class="col ms-3 table-dados" style="        margin-right: 19px;" v-if="idModulo != 0 && idInstituicao != 0">
                <DataTable :url_ajax="getUrlContatosPrioritarios()"
                           :customHeightPaginate="lowHeightPage" :customHeight="lowHeightNoPage"
                           :ajax_set_result="setHistorico" @grid_refreshed="gridRefreshed" :refresh="refresh_grid"
                           :filtros="filtro" method="GET" :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="false"
                           :headers="headersContatosPrioritarios" :pBtnsSlot="true"
                           :is_NotLoading="NotLoading" :is_modal="true" sizeWidBooton="width:102%;" :request_api="'comercial'">
                    <template v-slot:BtnSlot="item">
                        <div class="campo">
                            <div class="d-flex mb-1">
                                <div class="col" v-on:click="historicoPessoa(item.row.idPessoa)">
                                    <h3 class="mb-0">Nome</h3>
                                    <span class="data text-break" style="        text-align: left;">{{ item.row.nmPessoa }}</span>
                                </div>
                                <div class="col">
                                    <h3 class="mb-0">Departamento</h3>
                                    <span class="data">{{ item.row.nmDepartamento }}</span>
                                </div>
                                <div class="col">
                                    <button class="btn-grid-excluir-lista btn-arrow" @click="favoritar(item.row.idPessoa)">
                                        <i class="fas fa-arrow-left"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="col">
                                    <h3 class="mb-0">E-Mail</h3>
                                    <span class="data">{{ item.row.dsEmail }}</span>
                                </div>
                                <div class="col-4">
                                    <div class="row" v-if="item.row.flCelularValido && conta_whats_ativa">
                                        <div class="col-12">
                                            <button class="btn-grid-editar-lista btn-grid btn-whats" @click="OpenModalConfirmacaoIniciar(item.row.idPessoa)">
                                                <i class="fab fa-whatsapp"></i> <span class="btn-span-text">Whats</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid btn-editar"
                                                    @click="editContatoCrud(item.row.idPessoa)">
                                                <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid"
                                                    @click="ligar(item.row.idPessoa)">
                                                <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-12">
                                            <button type="button" class="btn-grid-editar-lista btn-grid btn-editar"
                                                    @click="editContatoCrud(item.row.idPessoa)">
                                                <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                                            </button>
                                            <button type="button" class="btn-grid-editar-lista btn-grid"
                                                    @click="ligar(item.row.idPessoa)">
                                                <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </DataTable>
            </div>
        </div>

        <div class="row box-ticket data-dados mt-5" v-if="ocorrencia.idPessoa > 0">
            <div class="d-flex">
                <div class="flex-fill">
                    <h3 class="mb-0">Nome</h3>
                    <span class="data text-break" style="        text-align: left;">{{ pessoa.nmPessoa }}</span>
                </div>
                <div class="flex-fill">
                    <h3 class="mb-0">E-Mail</h3>
                    <span class="data">{{ pessoa.dsEmail }}</span>
                </div>
                <div class="flex-fill">
                    <button type="button" class="btn-grid-editar-lista btn-grid"
                            @click="ligar(pessoa.idPessoa)">
                        <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                    </button>
                </div>
            </div>
        </div>

    </div>


    <modal-warper target="Ligacao_Crud" :show="isOpenModalLigacaoCrud" @close="(isOpenModalLigacaoCrud = false)">
        <LigacaoCrud :idOcorrencia="ocorrencia.idOcorrencia" :idPessoa="idPessoa" :show="isOpenModalLigacaoCrud" :idInstituicao="idInstituicao" :idModulo="idModulo" @ReloadGrid="reloadGrid" @AtualizaIdPessoa="handleIdPessoaChange" />
    </modal-warper>


    <modal-warper target="ContatoCrudNew" :show="isOpenModalConatoCrud" @close="(isOpenModalConatoCrud = false)">
        <ContatoCrud :idOcorrencia="idOcorrencia" :idPessoa="idPessoa" modalContatoId="ContatoCrudNew"
                     :show="isOpenModalConatoCrud" :idInstituicao="idInstituicao" @reloadGrid="reloadGrid" />
    </modal-warper>

    <modal-warper target="ModalConfirmacao_iniciar_conversa" :show="isOpenModalConfirmacaoIniciar" @close="(isOpenModalConfirmacaoIniciar = false)">
        <ModalConfirmacao id="iniciar_conversa" :title="'Iniciar Conversa'" :show="isOpenModalConfirmacaoIniciar" :haveText="false"
                          :description="''" :red="'Deseja realmente iniciar essa conversa?'" :action="'Iniciar conversa'" :isDelete="false"
                          @actionReturn="whats" :nm_validacao_txt="''" @fecharModal="fecharModal" />
    </modal-warper>

</template>

<script>

    import axios from 'axios';
    import ContatoCrud from '@/views/Modais/InstituicaoPessoas/PessoaCrud.vue'
    import LigacaoCrud from './../Modais/Ligacao_Crud'
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from './../../../../components/App/ModalWarper.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputSearch from './../../../../components/App/Input_Search.vue'
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue';

    export default {
        emits: ["setActionCard"],
        name: 'Contato',
        components: {
            ContatoCrud,
            DataTable,
            LigacaoCrud,
            ModalWarper,
            InputSearch,
            OcorrenciaInfo,
            ModalConfirmacao,
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                ocorrencia: {},

                refresh_grid: false,

                filtro: [
                    { active: true },
                ],

                headersContatosPrioritarios: [
                    { class: 'text-break', name: 'btns', text: 'Prioritários', actions: true, }
                ],

                headersTodosContatos: [
                    { class: 'text-break', name: 'btns', text: 'Contatos', actions: true, }
                ],

                headersHistoricoChamadas: [
                    { class: '', name: 'btns', text: 'Histórico de chamadas', actions: true, }
                ],

                idPessoa: 0,
                idModulo: 0,
                idInstituicao: 0,

                filtro_text: '',
                NotLoading: false,
                nrReloadGrid: 0,
                prioridade_Crud: {
                    idOcorrenciaPessoaPrioridade: 0,
                    idPessoa: 0,
                    idOcorrencia: 0
                },
                isOpenModalConatoCrud: false,
                isOpenModalLigacaoCrud: false,
                isOpenModalConfirmacaoIniciar: false,
                btnSizeDinamic: '',
                pessoa: {},
                lowHeightPage: '',
                lowHeightNoPage: '',
                conta_whats_ativa: false,
                idPessoaConversa: 0,
                dados: { idSetor: 0 },
            }
        },
        methods: {
            OpenModalConfirmacaoIniciar(_idPessoa) {
                this.idPessoaConversa = _idPessoa;

                this.isOpenModalConfirmacaoIniciar = true;
            },
            fecharModal() {
                this.idPessoaConversa = 0;
                this.isOpenModalConfirmacaoIniciar = false;
            },
            whats() {
                let $this = this;

                var request = { idModulo: $this.ocorrencia.idModulo, idInstituicao: $this.ocorrencia.idInstituicao, idPessoa: $this.idPessoaConversa }

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/WhatsConversa/IniciarConversa', request, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.$emit('clickTab', 22);
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            updatebtnSizeDinamic() {
                if (window.innerWidth >= 3500) {
                    this.btnSizeDinamic = 'width:40%;';
                } else {
                    this.btnSizeDinamic = 'width:65%;';
                }
            },
            updateLowHeight() {
                if (window.innerWidth <= 1600) {
                    this.lowHeightPage = 'max-height: calc(100vh - 16.5rem);min-height: calc(100vh - 16.5rem);margin-top:0px !important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 14rem);min-height: calc(100vh - 14rem);margin-top:0px !important';
                }
                else if (window.innerWidth >= 1601) {
                    this.lowHeightPage = 'max-height: calc(100vh - 26rem); min-height: calc(100vh - 26rem); margin-top: 0px!important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 23.3rem); min-height: calc(100vh - 23.3rem); margin-top: 0px!important';
                }
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
            },
            pesquisar() {
                let $this = this;

                $this.filtro1 = $this.setfiltro;

                $this.reloadGrid();
            },
            limparFiltro() {
                let $this = this;

                $this.filtro1 = '';
                $this.setfiltro = '';
                $this.idPessoa = 0;
                $this.reloadGrid();
            },
            ligar(idPessoa) {
                let $this = this;

                $this.idPessoa = idPessoa;
                $this.isOpenModalLigacaoCrud = true;
            },
            handleIdPessoaChange(novoIdPessoa) {
                let $this = this;

                $this.idPessoa = novoIdPessoa;
                $this.isOpenModalLigacaoCrud = false;
                setTimeout(() => {
                    $this.isOpenModalLigacaoCrud = true;
                }, 100)
            },
            historicoPessoa(idPessoa) {
                let $this = this;

                if ($this.idPessoa == idPessoa) {
                    $this.idPessoa = 0;
                } else {
                    $this.idPessoa = idPessoa;
                    $this.nrReloadGrid += 1;
                }

                $this.reloadGrid();
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.idModulo = $this.ocorrencia.idModulo;
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;
                    $this.getPessoa();
                    $this.getDadosOcorrencia();
                })
                $this.reloadGrid();
            },
            getUrlContatosPrioritarios() {
                let $this = this;

                let importante = 'Sim'

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetPessoaLigacao?idInstituicao=' + $this.idInstituicao + '&idOcorrencia=' + $this.idOcorrencia + '&importante=' + importante;
            },
            getUrlTodosContatos() {
                let $this = this;

                let importante = ''

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetPessoaLigacao?idInstituicao=' + $this.idInstituicao + '&idOcorrencia=' + $this.idOcorrencia + '&importante=' + importante;
            },
            func_crud(idPessoa, tpAlteracao) {

                this.idPessoa = idPessoa;

                if (tpAlteracao == 'Alterar') {
                    this.isOpenModalConatoCrud = true;
                }
                else {
                    //$this.ModalConfirmacaoView = new window.bootstrap.Modal(document.getElementById('ModalConfirmacao_lista_crud_delete'), {
                    //    keyboard: false
                    //});
                    //$this.ModalConfirmacaoView.show();
                }
            },
            favoritar(idPessoa) {
                let $this = this;

                $this.prioridade_Crud.idOcorrencia = $this.idOcorrencia
                $this.prioridade_Crud.idPessoa = idPessoa

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaPessoaPrioridade/Post', $this.prioridade_Crud, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.reloadGrid();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            removerFavorito(idPessoa) {
                let $this = this;

                axios.delete(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaPessoaPrioridade/Delete?idPessoa=' + idPessoa + '&idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.reloadGrid();
                }).catch(error => {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });
            },
            editContatoCrud(_idPessoa) {
                this.idPessoa = _idPessoa;
                this.isOpenModalConatoCrud = true;
            },

            newContatoCrud() {
                this.idPessoa = 0;
                this.isOpenModalConatoCrud = true;
            },

            setHistorico(result) {
                result.forEach((value, index) => {
                    if (value.flProcessada) {
                        value.flProcessada = '<i class="fas fa-check icon-grid-lista-check" style="color: #34A853"></i>';
                    } else {
                        value.flProcessada = '<i class="fas fa-times icon-grid-lista-uncheck" style="color: #9F3029"></i>';
                    }
                })
                return result;
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
            getPessoa() {
                let $this = this;

                $this.pessoa_instituicao = [];

                if ($this.ocorrencia.idInstituicao > 0) {
                    //axios.get(
                    //    process.env.VUE_APP_ROOT_COMERCIAL_API + "/PessoaInstituicao/GetPessoasInstituicao?idInstituicao=" + $this.ocorrencia.idInstituicao,
                    //    {
                    //        headers: $this.$api.getTokenComercial(),
                    //    }
                    //).then((response) => {
                    //    $this.pessoa_instituicao = response.data.data;
                    //});
                }
                else {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Pessoa/GetPessoaById?id=" + $this.ocorrencia.idPessoa,
                        {
                            headers: $this.$api.getTokenComercial(),
                        }
                    ).then((response) => {
                        $this.pessoa = response.data.data;
                    });
                }
            },
            getDadosOcorrencia() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    notLoading: true
                }).then(response => {
                    $this.dados = response.data.data;
                    $this.verificaContaAtiva();
                })
            },
            verificaContaAtiva() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Conta/VerificaContaAtiva?idModulo=' + $this.ocorrencia.idModulo + '&idSetor=' + $this.dados.idSetor, {
                    headers: $this.$api.getTokenComercial(),
                    notLoading: true
                }).then(response => {
                    if (response.data.data == true) {
                        $this.conta_whats_ativa = true;
                    }
                })
            },
        },
        mounted() {
            this.getOcorrencia();
            this.updatebtnSizeDinamic();
            this.updateLowHeight();

            window.addEventListener('resize', this.updateLowHeight);
            window.addEventListener('resize', this.updatebtnSizeDinamic);
        },
        updated() {
            this.updatebtnSizeDinamic();
            this.updateLowHeight();
        },
        watch: {
            idOcorrencia(newValue, oldValue) {
                this.getOcorrencia();
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;
                $this.filtro[0].value = newVal;
            },
            idPessoa(newValue, oldValue) {
                let $this = this;

                $this.nrReloadGrid += 1
            }
        }
    }

</script>

<style scoped lang="scss">

    .data-dados {
        padding-left: 12px;
        padding-right: 6px;
    }

    .btn-arrow {
        min-width: 84px;
        max-width: 84px !important;
        margin: 0px !important;
    }

    .btn-grid {
        min-width: 84px;
    }

    .btn-grid:hover {
        padding: 7px 11px !important;
    }

    .btn-whats {
        background-color: #1EB456 !important;
    }

    .btn-whats:hover {
        background-color: #1EB456 !important;
    }

    .sem_registro {
        color: #ACACAC;
        text-align: center;
        font-size: 14px;
        font-family: Inter;
        line-height: 140.625%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 8px;
        border-radius: 5px;
        background: #FFF;
        height: 80px;
        padding: 30px;
        min-height: calc(100vh - 330px);
    }

    .tem_registro {
        color: #ACACAC;
        font-size: 14px;
        font-family: Inter;
        line-height: 140.625%;
        margin: 0 8px;
        border: 1px solid #9F3029;
        border-radius: 5px;
        background: #FFF;
        height: 80px;
        padding: 8px;
        min-height: calc(100vh - 330px);
    }

    h3 {
        color: #434343;
        font-size: 12px;
        font-family: Inter;
        font-weight: 700;
        text-align: left
    }


    .data {
        float: left;
    }

    .campo {
        border-radius: 5px;
        padding: 8px;
    }

    .card_registro {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
    }

    .solid_bar {
        width: 4px;
        margin-right: 8px;
        border-radius: 2px;
        background: #9F3029;
    }

    .card_contato {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
        text-align: center;
    }

    .table-dados {
        padding-right: 0;
        margin-top: 4px;
        /* overflow: auto; */
        // height: calc(100vh - 25vh);
    }

    .btn-grid-excluir-lista {
        padding: 7px 10px !important;
        max-width: 43%;
    }

    .btn-grid-editar-lista {
        padding: 7px 11px !important;
    }

    .btn-editar {
        background-color: #6c757d;
    }

    .btn-editar:hover {
        background-color: #6c757d;
    }

    .btn.btn-red {
        &.add {
            width: 50%;
            margin-top: 45px;
            height: 40px;
            float: right;
            margin-right: 10px;
        }
    }

    @media screen and (max-width: 1400px) {
        .btn-span-text {
            &.favoritar {
                display: none;
            }

            &.excluir-favorito {
                display: none;
            }
        }

        .btn-grid-excluir-lista {
            max-width: 76px !important;
            margin: 0 10px 0 10px !important;
        }

        .span-add {
            display: none;
        }
    }</style>